var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.898 2.383c.47 1.64.47 5.156.47 5.156s0 3.477-.47 5.156a2.6 2.6 0 0 1-1.875 1.875c-1.68.43-8.32.43-8.32.43s-6.68 0-8.36-.43A2.6 2.6 0 0 1 .47 12.695C0 11.015 0 7.54 0 7.54s0-3.516.469-5.156A2.66 2.66 0 0 1 2.344.469C4.024 0 10.704 0 10.704 0s6.64 0 8.32.469c.898.234 1.64.976 1.874 1.914m-12.382 8.32 5.547-3.164-5.547-3.164z"
})));
export default SvgYoutube;